"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const OptList_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/ExtraOptions/OptList.vue"));
const OptValRangeNumber_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/ExtraOptions/OptValRangeNumber.vue"));
const OptValRangeDate_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/ExtraOptions/OptValRangeDate.vue"));
const OptBool_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/ExtraOptions/OptBool.vue"));
let FilteringItem = class FilteringItem extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.has_error = false;
    }
    get filters() {
        return this.heatmap.availableFilters();
    }
    remove() {
        this.$emit('remove');
    }
    onChangeFilter() {
        if (!this.filterWithValue.filter) {
            this.remove();
            return;
        }
        this.filterWithValue.reset();
    }
    onChangeFilterValue() {
        this.$emit('change');
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], FilteringItem.prototype, "heatmap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], FilteringItem.prototype, "filterWithValue", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('filterWithValue.filter')
], FilteringItem.prototype, "onChangeFilter", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('filterWithValue.value')
], FilteringItem.prototype, "onChangeFilterValue", null);
FilteringItem = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Check: lucide_vue_next_1.Check,
            OptList: OptList_vue_1.default,
            OptValRangeNumber: OptValRangeNumber_vue_1.default,
            OptValRangeDate: OptValRangeDate_vue_1.default,
            OptBool: OptBool_vue_1.default,
            Trash: lucide_vue_next_1.Trash,
            User: lucide_vue_next_1.User
        }
    })
], FilteringItem);
exports.default = FilteringItem;
